// Per-map-number URLs of the real-mesh .glb models (extracted from the game
// via tools/fft-map). Parcel resolves each new URL(…, import.meta.url) literal
// statically, so this table must stay literal — no loops. Shared by
// MapDetailView and the bracket's 3D map hover.
export const MESH_URLS = {
  0: new URL('../data/meshes/map000.glb', import.meta.url).href,
  1: new URL('../data/meshes/map001.glb', import.meta.url).href,
  2: new URL('../data/meshes/map002.glb', import.meta.url).href,
  3: new URL('../data/meshes/map003.glb', import.meta.url).href,
  4: new URL('../data/meshes/map004.glb', import.meta.url).href,
  5: new URL('../data/meshes/map005.glb', import.meta.url).href,
  6: new URL('../data/meshes/map006.glb', import.meta.url).href,
  7: new URL('../data/meshes/map007.glb', import.meta.url).href,
  8: new URL('../data/meshes/map008.glb', import.meta.url).href,
  9: new URL('../data/meshes/map009.glb', import.meta.url).href,
  10: new URL('../data/meshes/map010.glb', import.meta.url).href,
  11: new URL('../data/meshes/map011.glb', import.meta.url).href,
  12: new URL('../data/meshes/map012.glb', import.meta.url).href,
  13: new URL('../data/meshes/map013.glb', import.meta.url).href,
  14: new URL('../data/meshes/map014.glb', import.meta.url).href,
  15: new URL('../data/meshes/map015.glb', import.meta.url).href,
  16: new URL('../data/meshes/map016.glb', import.meta.url).href,
  17: new URL('../data/meshes/map017.glb', import.meta.url).href,
  18: new URL('../data/meshes/map018.glb', import.meta.url).href,
  19: new URL('../data/meshes/map019.glb', import.meta.url).href,
  20: new URL('../data/meshes/map020.glb', import.meta.url).href,
  21: new URL('../data/meshes/map021.glb', import.meta.url).href,
  22: new URL('../data/meshes/map022.glb', import.meta.url).href,
  23: new URL('../data/meshes/map023.glb', import.meta.url).href,
  24: new URL('../data/meshes/map024.glb', import.meta.url).href,
  25: new URL('../data/meshes/map025.glb', import.meta.url).href,
  26: new URL('../data/meshes/map026.glb', import.meta.url).href,
  27: new URL('../data/meshes/map027.glb', import.meta.url).href,
  28: new URL('../data/meshes/map028.glb', import.meta.url).href,
  29: new URL('../data/meshes/map029.glb', import.meta.url).href,
  30: new URL('../data/meshes/map030.glb', import.meta.url).href,
  31: new URL('../data/meshes/map031.glb', import.meta.url).href,
  32: new URL('../data/meshes/map032.glb', import.meta.url).href,
  33: new URL('../data/meshes/map033.glb', import.meta.url).href,
  34: new URL('../data/meshes/map034.glb', import.meta.url).href,
  35: new URL('../data/meshes/map035.glb', import.meta.url).href,
  36: new URL('../data/meshes/map036.glb', import.meta.url).href,
  37: new URL('../data/meshes/map037.glb', import.meta.url).href,
  38: new URL('../data/meshes/map038.glb', import.meta.url).href,
  39: new URL('../data/meshes/map039.glb', import.meta.url).href,
  40: new URL('../data/meshes/map040.glb', import.meta.url).href,
  41: new URL('../data/meshes/map041.glb', import.meta.url).href,
  42: new URL('../data/meshes/map042.glb', import.meta.url).href,
  43: new URL('../data/meshes/map043.glb', import.meta.url).href,
  44: new URL('../data/meshes/map044.glb', import.meta.url).href,
  45: new URL('../data/meshes/map045.glb', import.meta.url).href,
  46: new URL('../data/meshes/map046.glb', import.meta.url).href,
  47: new URL('../data/meshes/map047.glb', import.meta.url).href,
  48: new URL('../data/meshes/map048.glb', import.meta.url).href,
  49: new URL('../data/meshes/map049.glb', import.meta.url).href,
  50: new URL('../data/meshes/map050.glb', import.meta.url).href,
  51: new URL('../data/meshes/map051.glb', import.meta.url).href,
  52: new URL('../data/meshes/map052.glb', import.meta.url).href,
  53: new URL('../data/meshes/map053.glb', import.meta.url).href,
  54: new URL('../data/meshes/map054.glb', import.meta.url).href,
  55: new URL('../data/meshes/map055.glb', import.meta.url).href,
  56: new URL('../data/meshes/map056.glb', import.meta.url).href,
  57: new URL('../data/meshes/map057.glb', import.meta.url).href,
  58: new URL('../data/meshes/map058.glb', import.meta.url).href,
  59: new URL('../data/meshes/map059.glb', import.meta.url).href,
  60: new URL('../data/meshes/map060.glb', import.meta.url).href,
  61: new URL('../data/meshes/map061.glb', import.meta.url).href,
  62: new URL('../data/meshes/map062.glb', import.meta.url).href,
  63: new URL('../data/meshes/map063.glb', import.meta.url).href,
  64: new URL('../data/meshes/map064.glb', import.meta.url).href,
  65: new URL('../data/meshes/map065.glb', import.meta.url).href,
  66: new URL('../data/meshes/map066.glb', import.meta.url).href,
  67: new URL('../data/meshes/map067.glb', import.meta.url).href,
  68: new URL('../data/meshes/map068.glb', import.meta.url).href,
  69: new URL('../data/meshes/map069.glb', import.meta.url).href,
  70: new URL('../data/meshes/map070.glb', import.meta.url).href,
  71: new URL('../data/meshes/map071.glb', import.meta.url).href,
  72: new URL('../data/meshes/map072.glb', import.meta.url).href,
  73: new URL('../data/meshes/map073.glb', import.meta.url).href,
  74: new URL('../data/meshes/map074.glb', import.meta.url).href,
  75: new URL('../data/meshes/map075.glb', import.meta.url).href,
  76: new URL('../data/meshes/map076.glb', import.meta.url).href,
  77: new URL('../data/meshes/map077.glb', import.meta.url).href,
  78: new URL('../data/meshes/map078.glb', import.meta.url).href,
  79: new URL('../data/meshes/map079.glb', import.meta.url).href,
  80: new URL('../data/meshes/map080.glb', import.meta.url).href,
  81: new URL('../data/meshes/map081.glb', import.meta.url).href,
  82: new URL('../data/meshes/map082.glb', import.meta.url).href,
  83: new URL('../data/meshes/map083.glb', import.meta.url).href,
  84: new URL('../data/meshes/map084.glb', import.meta.url).href,
  85: new URL('../data/meshes/map085.glb', import.meta.url).href,
  86: new URL('../data/meshes/map086.glb', import.meta.url).href,
  87: new URL('../data/meshes/map087.glb', import.meta.url).href,
  88: new URL('../data/meshes/map088.glb', import.meta.url).href,
  89: new URL('../data/meshes/map089.glb', import.meta.url).href,
  90: new URL('../data/meshes/map090.glb', import.meta.url).href,
  91: new URL('../data/meshes/map091.glb', import.meta.url).href,
  92: new URL('../data/meshes/map092.glb', import.meta.url).href,
  93: new URL('../data/meshes/map093.glb', import.meta.url).href,
  94: new URL('../data/meshes/map094.glb', import.meta.url).href,
  95: new URL('../data/meshes/map095.glb', import.meta.url).href,
  96: new URL('../data/meshes/map096.glb', import.meta.url).href,
  97: new URL('../data/meshes/map097.glb', import.meta.url).href,
  98: new URL('../data/meshes/map098.glb', import.meta.url).href,
  99: new URL('../data/meshes/map099.glb', import.meta.url).href,
  100: new URL('../data/meshes/map100.glb', import.meta.url).href,
  101: new URL('../data/meshes/map101.glb', import.meta.url).href,
  102: new URL('../data/meshes/map102.glb', import.meta.url).href,
  103: new URL('../data/meshes/map103.glb', import.meta.url).href,
  104: new URL('../data/meshes/map104.glb', import.meta.url).href,
  105: new URL('../data/meshes/map105.glb', import.meta.url).href,
  106: new URL('../data/meshes/map106.glb', import.meta.url).href,
  107: new URL('../data/meshes/map107.glb', import.meta.url).href,
  108: new URL('../data/meshes/map108.glb', import.meta.url).href,
  109: new URL('../data/meshes/map109.glb', import.meta.url).href,
  110: new URL('../data/meshes/map110.glb', import.meta.url).href,
  111: new URL('../data/meshes/map111.glb', import.meta.url).href,
  112: new URL('../data/meshes/map112.glb', import.meta.url).href,
  113: new URL('../data/meshes/map113.glb', import.meta.url).href,
  114: new URL('../data/meshes/map114.glb', import.meta.url).href,
  115: new URL('../data/meshes/map115.glb', import.meta.url).href,
  116: new URL('../data/meshes/map116.glb', import.meta.url).href,
  117: new URL('../data/meshes/map117.glb', import.meta.url).href,
  118: new URL('../data/meshes/map118.glb', import.meta.url).href,
  119: new URL('../data/meshes/map119.glb', import.meta.url).href,
  125: new URL('../data/meshes/map125.glb', import.meta.url).href,
};
